






























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import ITicket from '@/api/interface/ITicket';
import TypeUtils from '@/api/util/TypeUtils';
import FormatUtils from '@/api/util/FormatUtils';
import AddressUtils from '@/api/util/AddressUtils';

@Component
export default class TicketCheckoutCatalogItem extends Vue {
  @Prop(Object) public readonly ticket!: ITicket;
  @Prop(Number) public readonly value!: number;
  @Prop(String) public readonly currencyCode!: string;
  @Prop(Boolean) public readonly disabled!: boolean;

  public mounted() {
    if (this.value === undefined || this.value === null) {
      this.$emit('input', 0);
    }
  }

  get remainingTickets() {
    if (this.ticket.showRemainingQuantity) {
      return this.ticket.quantity - this.value;
    }
  }

  private formatPrice(val: any) {
    return TypeUtils.toFloat(val) === 0
      ? 'Free'
      : FormatUtils.formatCurrency(val, this.currencyCode);
  }
}
